module.exports = __webpack_public_path__ + "static/media/walmarticon.1db30728.svg";